/**
 * Tell the platform a licence NFT just changed hands, so its registry — and
 * therefore every licence list — reflects the movement immediately.
 *
 * Without this call the background indexer needs up to a minute to see the
 * transfer and the list cache holds for another, during which the sender
 * still sees the licence and the receiver does not, however many times the
 * page is reloaded. Called right after the transaction confirms, it makes
 * the very next fetch already true.
 *
 * Failure is deliberately silent: the background indexer is the guarantee,
 * this is the acceleration.
 */
const BASE =
  (import.meta.env.VITE_INDEX_NODE_SERVICE_API_URL as string | undefined) ??
  '/api/index-node-licenses/'

export async function reflectLicenceTransfer(
  nftContract: string,
  tokenId: string
): Promise<void> {
  try {
    const url = `${BASE.replace(/\/$/, '')}/licenses/transferred/${nftContract.toLowerCase()}/${tokenId}`
    await fetch(url, { method: 'POST' })
  } catch {
    // The indexer will catch the movement within a minute either way.
  }
}
